export const getStepsInRange = (rangeStart: number, rangeEnd: number, numberOfSteps: number): Array<number> => {
  const valueRangePerScaleStep = (rangeEnd - rangeStart) / (numberOfSteps - 1);
  const steps = [rangeStart];

  for (let i = 1; i < numberOfSteps - 1; i++) {
    steps.push(rangeStart + i * valueRangePerScaleStep);
  }

  steps.push(rangeEnd);

  return steps;
};
